import React, { useState } from "react";
import "./Button.scss";

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  label: string;
}

const Button = ({ label, ...others }: ButtonProps) => {
  const [count, setCount] = useState(1);
  return (
    <button
      className="text-3xl font-bold underline text-red-700"
      onClick={() => {
        setCount((old) => old + 1);
      }}
      {...others}
    >
      {label} carlos Marios {count}
    </button>
  );
};

export default Button;
